import React, { useEffect } from "react";
import label from "../../labels/administration_en.json";

const ExamActivates = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div className="dashboardContentArea">
      <h5> {label.ExamActivates} </h5>
      <div className="row dashboardCards"></div>
    </div>
  );
};

export default ExamActivates;
